import type { UserCategory } from '@/api/models/definitions'
import { MotionBoxType } from '@/modules/motion/types/motion.enums'

export interface Item {
  id: number
  label: string
  icon?: string
  active?: boolean
  items?: Item[]
}

export interface MotionTrack {
  id: number
  index: number
  status: number
  mType: MotionBoxType
}

export const MotionTrackDefault: MotionTrack = {
  id: 0,
  index: -1,
  status: -1,
  mType: MotionBoxType.None,
}

export interface EventItem {
  eventCode: string
  label: string
}

export interface UserCategoryItem {
  id: UserCategory
  label: string
}
